import { render, staticRenderFns } from "./ResponsibilityDirectoryFormMenu.vue?vue&type=template&id=73f171d6&scoped=true"
import script from "./ResponsibilityDirectoryFormMenu.vue?vue&type=script&lang=js"
export * from "./ResponsibilityDirectoryFormMenu.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityDirectoryFormMenu.vue?vue&type=style&index=0&id=73f171d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f171d6",
  null
  
)

export default component.exports